import React from 'react';
import {IoMdClose as CloseIcon} from 'react-icons/io';

import MoveTo from './MoveTo';
import DropdownWrapper from './DropdownWrapper';
import {compareString} from '../../utils/ArrayUtils';
import {Tag} from "../../models/Tag";
import {TrackCategory} from '../../models/TrackCategory';

interface Props {
    categoryIds: string[],
    allCategories: TrackCategory[],
    addCategory: (category: TrackCategory) => void,
    removeCategory: (categoryId: string) => void,
    sourceItem: any
}

export const TrackCategoriesInput = ({categoryIds, allCategories, addCategory, removeCategory, sourceItem}: Props) => {
  return <DropdownWrapper style={{right: '31%', paddingTop: '3px'}} isRevert={true} isRerender={true}>
    <div className={'tags-input-container'}>
      {
        categoryIds.map((tagId) => {
          const tag = allCategories.find((tag) => tag.id === tagId);
          if (!tag) {
              throw new Error('Category not found');
          }
          return <div className={'tag-badge'}
            key={tagId}
          >
            {`${tag.name}`}
            <div className={'close-tag'}>
              <CloseIcon
                onClick={(e) => {
                  e.stopPropagation();
                  removeCategory(tagId);
                }}
                style={{paddingLeft: '5px', width: '20px'}}
              />
            </div>
          </div>;
        })
      }
    </div>

    <MoveTo
      moveTo={(sourceItem: any, category: TrackCategory) => {
        addCategory(category);
      }}
      items={allCategories
          .filter((category) => {
            return !categoryIds.find((categoryId) => {
              return categoryId === category.id;
            }) && category.isActive;
          })
          .sort(compareString('name'))
      }
      isFocus={true}
      isClose={false}
      propName={'name'}
      renderProp={(category: TrackCategory) => {
        return `${category.name} (${category.tracksToCategory.length})`;
      }}
      placeholder={'Search'}
      sourceItem={sourceItem}
      containerClassName={'component-settings-container'}
    />

  </DropdownWrapper>;
};
